<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">费用明细表</span></div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <DatePicker type="year" v-model="year" format="YYYY" style="width: 120px"
                    :clearable="false"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button icon="fa fa-refresh" :loading="loading" @click="loadList">刷新</Button>
        <Button @click="doExport">导出</Button>
        <Button icon="fa fa-print" @click="doPrint">打印</Button>
      </Cell>
    </Row>
    <Row type="flex" :space-x="20" class="margin-right-left margin-top">
      <Cell><Checkbox v-model="options.yearTotal">年度合计</Checkbox></Cell>
      <Cell><Checkbox v-model="options.expandAll">展开所有层级</Checkbox></Cell>
      <Cell><Checkbox v-model="options.fullName">明细科目显示全称</Checkbox></Cell>
      <Cell><Checkbox v-model="options.showZero">展示发生额为0的科目</Checkbox></Cell>
    </Row>
    <div class="h-panel-body" style="overflow-x: auto;">
      <table class="fee-table">
        <thead>
        <tr>
          <th>编码</th>
          <th>名称</th>
          <th v-for="m in 12" :key="m">{{ m }}月</th>
          <th>合计</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in showList" :key="index">
          <td>{{ item.code }}</td>
          <td :style="{'padding-left': ((item.level || 0) * 12 + 8) + 'px'}">
            {{ options.fullName ? (item.fullName || item.name) : item.name }}
          </td>
          <td v-for="m in 12" :key="m" align="right">{{ monthVal(item, m) | numFormat }}</td>
          <td align="right"><b>{{ rowTotal(item) | numFormat }}</b></td>
        </tr>
        <tr v-if="!showList.length">
          <td colspan="15" class="text-center padding">暂无数据</td>
        </tr>
        </tbody>
        <tfoot v-if="options.yearTotal && showList.length">
        <tr>
          <td colspan="2" align="right"><b>年度合计</b></td>
          <td v-for="m in 12" :key="m" align="right"><b>{{ columnTotal(m) | numFormat }}</b></td>
          <td align="right"><b>{{ grandTotal | numFormat }}</b></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </app-content>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

export default {
  name: 'FeeDetailReportPage',
  data() {
    return {
      year: moment().format('YYYY'),
      options: {
        yearTotal: true,
        expandAll: false,
        fullName: false,
        showZero: false
      },
      dataList: [],
      loading: false
    }
  },
  computed: {
    showList() {
      let list = this.dataList;
      //未勾选"展开所有层级"时仅展示前两级科目
      if (!this.options.expandAll) {
        list = list.filter(item => (item.level || 0) <= 1);
      }
      if (!this.options.showZero) {
        list = list.filter(item => this.rowTotal(item) !== 0);
      }
      return list;
    },
    grandTotal() {
      return this.showList.reduce((sum, item) => sum + this.rowTotal(item), 0);
    }
  },
  methods: {
    monthVal(item, m) {
      if (Array.isArray(item.months) && item.months.length) {
        return item.months[m - 1] || 0;
      }
      return item['m' + m] !== undefined ? item['m' + m] : (item['month' + m] || 0);
    },
    rowTotal(item) {
      if (item.total !== undefined) {
        return Number(item.total) || 0;
      }
      let total = 0;
      for (let m = 1; m <= 12; m++) {
        total += Number(this.monthVal(item, m)) || 0;
      }
      return Math.round(total * 100) / 100;
    },
    columnTotal(m) {
      return this.showList.reduce((sum, item) => sum + (Number(this.monthVal(item, m)) || 0), 0);
    },
    normalize(item) {
      return Object.assign({
        code: item.code || '',
        name: item.name || '',
        fullName: item.fullName || item.subjectFullName || item.name,
        level: item.level || 0,
        months: item.months || null,
        total: item.total
      }, item);
    },
    loadList() {
      this.loading = true;
      this.$api.report.feeDetail(Object.assign({year: this.year}, this.options)).then(({data}) => {
        let list = data.results || data.rows || data || [];
        this.dataList = (Array.isArray(list) ? list : []).map(item => this.normalize(item));
      }).catch(() => {
        this.$Message.error('费用明细表加载失败');
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.loadList();
    },
    doExport() {
      let headers = ['编码', '名称'];
      for (let m = 1; m <= 12; m++) {
        headers.push(m + '月');
      }
      headers.push('合计');
      let rows = this.showList.map(item => {
        let row = [item.code, this.options.fullName ? (item.fullName || item.name) : item.name];
        for (let m = 1; m <= 12; m++) {
          row.push(this.monthVal(item, m));
        }
        row.push(this.rowTotal(item));
        return row;
      });
      exportCsv(`费用明细表_${this.year}`, headers, rows);
    },
    doPrint() {
      window.print();
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.fee-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;

  th, td {
    padding: 6px 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }

  tfoot td {
    background: #f5f5f5;
  }
}
</style>
